/**
 * Returns the count of words from the last element of a specified type until the
 * end of the provided injected array
 * @param {Array} injectedArray Original graphQL body array injected with elements.
 * @param {String} typeToStartCount Type of last element to start counting from.
 * @returns {Number}
 */
const getWordCountFromLastIndexOfTypeToEndOfArray = ({ injectedArray, typeToStartCount }) => {
  let wordCountFromCurrIdxToEnd;

  for (let i = injectedArray.length - 1; i > 0; i--) {
    let subArray;

    if (injectedArray[i].type === typeToStartCount) {
      subArray = injectedArray.slice(i + 1);
    }

    if (subArray) {
      wordCountFromCurrIdxToEnd = subArray.reduce((accumulator, currentValue) => {
        if (currentValue.wordCount) {
          return accumulator + currentValue.wordCount;
        }
        return accumulator;
      }, 0);

      break;
    }
  }

  return wordCountFromCurrIdxToEnd;
};

export default getWordCountFromLastIndexOfTypeToEndOfArray;
